function normalizeBaseUrl(value: string | undefined | null): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;
  return trimmed.replace(/\/+$/, "");
}

const developmentGatewayKey = "more-pos:dev-gateway-base-url";

export function getGatewayBaseUrl(): string | null {
  const configured = normalizeBaseUrl(import.meta.env.VITE_MORE_POS_GATEWAY_BASE_URL);
  if (configured) return configured;

  if (import.meta.env.DEV) {
    return normalizeBaseUrl(window.sessionStorage.getItem(developmentGatewayKey));
  }

  return null;
}

export function setDevelopmentGatewayBaseUrl(value: string) {
  if (!import.meta.env.DEV) return;
  const normalized = normalizeBaseUrl(value);
  if (normalized) {
    window.sessionStorage.setItem(developmentGatewayKey, normalized);
  } else {
    window.sessionStorage.removeItem(developmentGatewayKey);
  }
}

export const runtimeConfig = Object.freeze({
  buildMode: import.meta.env.MODE,
  developmentGatewayOverrideAllowed: import.meta.env.DEV,
});
